import "./App.css";
import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Cookies from "js-cookie";

import Portal from "./Layout/PortalLayout";
import { usePermissions } from "./Utils/PermissionsContext";
import managePermissionService from "./Services/managePermissionService";
import logServices from "./Services/logService";
import Loading from "./Components/Loading";

// --- Screens ---
import Dashboard from "./Screen/Dashboard";
import CarMakers from "./Screen/CarMakers";
import ImportProducts from "./Screen/ImportProducts";
import Products from "./Screen/Products";
import Customers from "./Screen/Customers";
import Users from "./Screen/Users";
import OrderCustomers from "./Screen/OrderCustomers";
import OrderDetail from "./Screen/OrderDetail";
import Order from "./Screen/Order";
import OrderView from "./Screen/OrderView";
import Login from "./Screen/Login";
import Suppliers from "./Screen/Suppliers";
import AddSupplier from "./Screen/AddSupplier";
import CustomerLedger from "./Screen/CustomerLedger";
import SupplierLedger from "./Screen/SupplierLedger";
import News from "./Screen/News";
import AddNews from "./Screen/AddNews";
import AddOrder from "./Screen/AddOrder";
import PurchaseOrder from "./Screen/PurchaseOrder";
import CreatePurchaseOrder from "./Screen/CreatePurchaseOrder";
import PurchaseView from "./Screen/PurchaseView";
import AddCustomer from "./Screen/AddCustomer";
import PriceList from "./Screen/PriceList";
import AddQuotation from "./Screen/AddQuotation";
import Quotation from "./Screen/Quotation";
import ViewQuotation from "./Screen/ViewQuotation";
import QuotationOrder from "./Screen/QuotationOrder";
import Account from "./Screen/Account";
import AddAccount from "./Screen/AddAccount";
import Expenses from "./Screen/Expenses";
import AddExpensesHead from "./Screen/AddExpenseHead";
import AddExpense from "./Screen/AddExpense";
import AddIncome from "./Screen/AddIncome";
import Income from "./Screen/Income";
import AddJournalTransaction from "./Screen/AddJournalTransaction";
import ExpenseHead from "./Screen/ExpenseHead";
import ExpensesByExpenseHead from "./Screen/ExpensesByExpenseHead";
import JournalTransaction from "./Screen/JournalTransaction";
import Transactions from "./Screen/Transactions";
import AddMonthlyVoucher from "./Screen/MonthlyVoucher";
import AllMonthlyVouchers from "./Screen/AllMonthlyVouchers";
import Role from "./Screen/Role";
import Warehouse from "./Screen/Warehouse";
import AddWarehouse from "./Screen/AddWarehouse";
import Receiveable from "./Screen/Receiveable";
import AddPayable from "./Screen/AddPayable";
import AddReceiveable from "./Screen/AddReceiveable";
import ReceiveableView from "./Screen/ReceiveableView";
import PayableView from "./Screen/PayableView";
import AddRole from "./Screen/AddRole";
import AddUser from "./Screen/AddUser";
import Permissions from "./Screen/Permissions";
import AddPermission from "./Screen/AddPermission";
import Payable from "./Screen/Payable";
import ManagePermission from "./Screen/ManagePermission";
import PickingList from "./Screen/PickingList";
import Logs from "./Screen/Logs";
import Locations from "./Screen/Locations";
import AddLocation from "./Screen/AddLocation";
import AddPickingList from "./Screen/AddPickingList";
import ViewPickingList from "./Screen/ViewPickingList";
import LandingPage from "./Screen/LandingPage";
import AddOldOrder from "./Screen/AddOldOrder";
import AccountLedger from "./Screen/AccountLedger";
import SupplierPayments from "./Screen/SupplierPayments";
import UpdateQuotation from "./Screen/UpdateQuotation";
import Inventory from "./Screen/Inventory";
import AddInventory from "./Screen/AddInventory";
import AddSupplierPayments from "./Screen/AddSupplierPayments";
import CustomerDetailsEdit from "./Screen/CustomerDetailsEdit";
import CustomerVoucher from "./Screen/CustomerVoucher";
import SupplierVoucher from "./Screen/SupplierVoucher";
import AccountsVoucher from "./Screen/AccountsVoucher";
import AddCustomerVoucher from "./Screen/AddCustomerVoucher";
import AddSupplierVoucher from "./Screen/AddSupplierVoucher";
import Notes from "./Screen/Notes";
import Documents from "./Screen/Documents";
import AddDocument from "./Screen/AddDocument";
import CustomerPDFLedger from "./Modals/CustomerPDFLedger";
import PickingView from "./Screen/PickingView";
import ScannedProducts from "./Screen/ScannedProducts";
import AddPackingList from "./Screen/AddPackingList";
import PackingList from "./Screen/PackingList";
import PackingView from "./Screen/PackingView";
import PackedProducts from "./Screen/PackedProducts";
import PackedDetails from "./Screen/PackedDetails";
import StockDetails from "./Screen/StockDetails";
import AddpickingManually from "./Screen/AddpickingManually";
import AddProductsWithoutBarcode from "./Screen/AddProductsWithoutBarcode";
import StockLedger from "./Screen/StockLedger";
import CreatePurchaseOrderDirect from "./Screen/CreatePurchaseOrderDirect";
export default function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [application, setApplication] = useState(false);
  const location = useLocation();
  const { permissions, setPermissions } = usePermissions();
  // const [user, setUser] = useState(null);

  useEffect(() => {
    const authCookie = Cookies.get(
      "XIOQUNVU1RPTUVSLUFVVEhFTlRJQ0FUSU9OIMSLQ1JFVC1LRVk=",
    );
    setIsAuthenticated(!!authCookie);
  }, [location.pathname]);

  useEffect(() => {
    const fetchUserAndPermissions = async () => {
      const storedUserJSON = localStorage.getItem("user");
      if (!storedUserJSON) {
        setApplication(true);
        return;
      }

      let storedUser;
      try {
        storedUser = JSON.parse(storedUserJSON);
      } catch (e) {
        console.error("Failed to parse user JSON:", e);
        setApplication(true);
        return;
      }

      // setUser(storedUser);

      if (!storedUser?.role) {
        setApplication(true);
        return;
      }

      try {
        const response = await managePermissionService.fetchByRole(
          storedUser.role,
        );
        setPermissions(response.permissions);

        await logServices.create({
          user_id: storedUser.id,
          reference_id: storedUser.id,
          entity: storedUser.email,
          page: location.pathname,
          action: "OPEN_PAGE",
          timestamp: new Date().toISOString(),
        });
      } catch (e) {
        console.error("Error fetching permissions:", e);
      }

      setApplication(true);
    };

    if (isAuthenticated && permissions.length === 0) {
      fetchUserAndPermissions();
    } else {
      setApplication(true);
    }
  }, [isAuthenticated, permissions, location.pathname, setPermissions]);

  if (!application) return <Loading />;

  return (
    <Portal>
      <Routes>
        <Route
          path="/"
          element={isAuthenticated ? <LandingPage /> : <Navigate to="/login" />}
        />
        {/* <Route
          path="/noticeboard"
          element={isAuthenticated ? <NoticeBoard /> : <Navigate to="/login" />}
        /> */}
        <Route
          path="/dashboard"
          element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" />}
        />
        <Route
          path="/login"
          element={!isAuthenticated ? <Login /> : <Navigate to="/" />}
        />
        <Route
          path="/carmakers"
          element={isAuthenticated ? <CarMakers /> : <Navigate to="/login" />}
        />
        <Route
          path="/news"
          element={isAuthenticated ? <News /> : <Navigate to="/login" />}
        />
        <Route
          path="/news/add"
          element={isAuthenticated ? <AddNews /> : <Navigate to="/login" />}
        />
        <Route
          path="/importproducts"
          element={
            isAuthenticated ? <ImportProducts /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/stockdetails"
          element={
            isAuthenticated ? <StockDetails /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/products"
          element={isAuthenticated ? <Products /> : <Navigate to="/login" />}
        />
        <Route
          path="/customers"
          element={isAuthenticated ? <Customers /> : <Navigate to="/login" />}
        />
        <Route
          path="/customers/add"
          element={isAuthenticated ? <AddCustomer /> : <Navigate to="/login" />}
        />
        <Route
          path="/customers/edit"
          element={
            isAuthenticated ? <CustomerDetailsEdit /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/customers/ledger"
          element={
            isAuthenticated ? <CustomerLedger /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/customers/ledger/customerpdfinvoice"
          element={
            isAuthenticated ? <CustomerPDFLedger /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/users"
          element={isAuthenticated ? <Users /> : <Navigate to="/login" />}
        />
        <Route
          path="/users/add"
          element={isAuthenticated ? <AddUser /> : <Navigate to="/login" />}
        />
        <Route
          path="/users/edit"
          element={
            isAuthenticated ? (
              <AddUser edit={false} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/suppliers"
          element={isAuthenticated ? <Suppliers /> : <Navigate to="/login" />}
        />
        <Route
          path="/suppliers/ledger"
          element={
            isAuthenticated ? <SupplierLedger /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/ordercustomer"
          element={
            isAuthenticated ? <OrderCustomers /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/suppliers/add"
          element={isAuthenticated ? <AddSupplier /> : <Navigate to="/login" />}
        />
        <Route
          path="/order"
          element={isAuthenticated ? <Order /> : <Navigate to="/login" />}
        />
        <Route
          path="/order/add"
          element={isAuthenticated ? <AddOrder /> : <Navigate to="/login" />}
        />
        <Route
          path="/order/addOld"
          element={isAuthenticated ? <AddOldOrder /> : <Navigate to="/login" />}
        />
        <Route
          path="/order/view"
          element={isAuthenticated ? <OrderView /> : <Navigate to="/login" />}
        />
        <Route
          path="/orderDetails"
          element={isAuthenticated ? <OrderDetail /> : <Navigate to="/login" />}
        />
        <Route
          path="/purchase"
          element={
            isAuthenticated ? <PurchaseOrder /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/purchase/view"
          element={
            isAuthenticated ? <PurchaseView /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/purchase/view/addpicking"
          element={
            isAuthenticated ? <AddPickingList /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/purchase/view/addpickingmanual"
          element={
            isAuthenticated ? <AddpickingManually /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/addpacking"
          element={
            isAuthenticated ? <AddPackingList /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/purchase/add"
          element={
            isAuthenticated ? <CreatePurchaseOrder /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/purchase/addorder"
          element={
            isAuthenticated ? <CreatePurchaseOrderDirect /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/pricelist"
          element={isAuthenticated ? <PriceList /> : <Navigate to="/login" />}
        />
        <Route
          path="/quotation"
          element={isAuthenticated ? <Quotation /> : <Navigate to="/login" />}
        />
        <Route
          path="/quotation/add"
          element={
            isAuthenticated ? <AddQuotation /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/quotation/update"
          element={
            isAuthenticated ? <UpdateQuotation /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/quotation/view"
          element={
            isAuthenticated ? <ViewQuotation /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/quotation/get"
          element={
            isAuthenticated ? <QuotationOrder /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/roles"
          element={isAuthenticated ? <Role /> : <Navigate to="/login" />}
        />
        <Route
          path="/roles/add"
          element={isAuthenticated ? <AddRole /> : <Navigate to="/login" />}
        />
        <Route
          path="/roles/edit"
          element={
            isAuthenticated ? <AddRole edit={true} /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/roles/permission"
          element={
            isAuthenticated ? <ManagePermission /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/accounts"
          element={isAuthenticated ? <Account /> : <Navigate to="/login" />}
        />
        <Route
          path="/accounts/add"
          element={isAuthenticated ? <AddAccount /> : <Navigate to="/login" />}
        />
        <Route
          path="/accounts/accountLedger"
          element={
            isAuthenticated ? <AccountLedger /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/expenses"
          element={isAuthenticated ? <Expenses /> : <Navigate to="/login" />}
        />
        <Route
          path="/expenses/add"
          element={isAuthenticated ? <AddExpense /> : <Navigate to="/login" />}
        />
        <Route
          path="/expenses/head"
          element={isAuthenticated ? <ExpenseHead /> : <Navigate to="/login" />}
        />
        <Route
          path="/expenses/expenseHead"
          element={
            isAuthenticated ? (
              <ExpensesByExpenseHead />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/expenses/head/add"
          element={
            isAuthenticated ? <AddExpensesHead /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/incomes"
          element={isAuthenticated ? <Income /> : <Navigate to="/login" />}
        />
        <Route
          path="/incomes/add"
          element={isAuthenticated ? <AddIncome /> : <Navigate to="/login" />}
        />
        <Route
          path="/supplierpayments"
          element={
            isAuthenticated ? <SupplierPayments /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/supplierpayments/add"
          element={
            isAuthenticated ? <AddSupplierPayments /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/journals"
          element={
            isAuthenticated ? <JournalTransaction /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/journal/add"
          element={
            isAuthenticated ? (
              <AddJournalTransaction />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/transactions"
          element={
            isAuthenticated ? <Transactions /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/monthly/voucher"
          element={
            isAuthenticated ? <AllMonthlyVouchers /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/monthly/voucher/add"
          element={
            isAuthenticated ? <AddMonthlyVoucher /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/monthly/customerVoucher"
          element={
            isAuthenticated ? <CustomerVoucher /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/monthly/customerVoucher/add"
          element={
            isAuthenticated ? <AddCustomerVoucher /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/monthly/suppliervoucher"
          element={
            isAuthenticated ? <SupplierVoucher /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/monthly/suppliervoucher/add"
          element={
            isAuthenticated ? <AddSupplierVoucher /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/monthly/accountsvoucher"
          element={
            isAuthenticated ? <AccountsVoucher /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/payable"
          element={isAuthenticated ? <Payable /> : <Navigate to="/login" />}
        />
        <Route
          path="/payable/add"
          element={isAuthenticated ? <AddPayable /> : <Navigate to="/login" />}
        />
        <Route
          path="/payable/view"
          element={isAuthenticated ? <PayableView /> : <Navigate to="/login" />}
        />
        <Route
          path="/receiveable"
          element={isAuthenticated ? <Receiveable /> : <Navigate to="/login" />}
        />
        <Route
          path="/receiveable/add"
          element={
            isAuthenticated ? <AddReceiveable /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/receiveable/view"
          element={
            isAuthenticated ? <ReceiveableView /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/scannedproducts"
          element={
            isAuthenticated ? <ScannedProducts /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/packedproducts"
          element={
            isAuthenticated ? <PackedProducts /> : <Navigate to="/login" />
          }
        />

        <Route
          path="/packedproducts/add/:id"
          element={
            isAuthenticated ? (
              <AddProductsWithoutBarcode />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/warehouse"
          element={isAuthenticated ? <Warehouse /> : <Navigate to="/login" />}
        />
        <Route
          path="/warehouse/add"
          element={
            isAuthenticated ? <AddWarehouse /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/permission"
          element={isAuthenticated ? <Permissions /> : <Navigate to="/login" />}
        />
        <Route
          path="/permission/add"
          element={
            isAuthenticated ? <AddPermission /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/permission/edit"
          element={
            isAuthenticated ? (
              <AddPermission edit={true} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/pickinglist"
          element={
            isAuthenticated ? (
              <PickingList edit={true} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/packinglist"
          element={
            isAuthenticated ? (
              <PackingList edit={true} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/pickinglist/viewpicking"
          element={
            isAuthenticated ? (
              <ViewPickingList edit={true} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/logs"
          element={
            isAuthenticated ? <Logs edit={true} /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/location"
          element={isAuthenticated ? <Locations /> : <Navigate to="/login" />}
        />
        <Route
          path="/locations/add"
          element={isAuthenticated ? <AddLocation /> : <Navigate to="/login" />}
        />
        <Route
          path="/inventory"
          element={isAuthenticated ? <Inventory /> : <Navigate to="/login" />}
        />
        <Route
          path="/inventory/add"
          element={
            isAuthenticated ? <AddInventory /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/notes"
          element={isAuthenticated ? <Notes /> : <Navigate to="/login" />}
        />
        <Route
          path="/document"
          element={isAuthenticated ? <Documents /> : <Navigate to="/login" />}
        />
        <Route
          path="/document/add"
          element={isAuthenticated ? <AddDocument /> : <Navigate to="/login" />}
        />
        <Route
          path="/picking"
          element={isAuthenticated ? <PickingList /> : <Navigate to="/login" />}
        />
        <Route
          path="/picking/add"
          element={
            isAuthenticated ? <AddPickingList /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/picking/view/:id"
          element={isAuthenticated ? <PickingView /> : <Navigate to="/login" />}
        />
        <Route
          path="/packing/view/:id"
          element={isAuthenticated ? <PackingView /> : <Navigate to="/login" />}
        />
        <Route
          path="/packed/details/:barcode"
          element={
            isAuthenticated ? <PackedDetails /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/stockledger"
          element={isAuthenticated ? <StockLedger /> : <Navigate to="/login" />}
        />
      </Routes>
    </Portal>
  );
}
